import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const NAV = [
  { to: '/admin/seo', end: true, label: 'Dashboard' },
  { to: '/admin/seo/pages', label: 'Pages' },
  { to: '/admin/seo/priority/countries', label: 'T1/2/3 Countries' },
  { to: '/admin/seo/priority/destinations', label: 'T1/2/3 Destinations' },
  { to: '/admin/seo/priority/routes', label: 'T1/2/3 Routes' },
  { to: '/admin/seo/priority/airlines', label: 'T1/2/3 Airlines' },
  { to: '/admin/seo/priority/airports', label: 'T1/2/3 Airports' },
  { to: '/admin/seo/priority/visa', label: 'T1/2/3 Visa' },
  { to: '/admin/seo/import', label: 'Import & Sync' },
  { to: '/admin/seo/audit', label: 'Content Audit' },
  { to: '/admin/seo/health', label: 'Page Health' },
  { to: '/admin/seo/indexing', label: 'Indexing' },
  { to: '/admin/seo/sitemaps', label: 'Sitemaps' },
  { to: '/admin/seo/fares', label: 'Fare Cache' },
  { to: '/admin/seo/visa-data', label: 'Visa Data' },
  { to: '/admin/seo/baggage', label: 'Baggage' },
  { to: '/admin/seo/cron-runs', label: 'Cron Runs' },
  { to: '/admin/seo/api-failures', label: 'API Failures' },
  { to: '/admin/seo/logs', label: 'Audit Logs' },
];

export default function SeoControlCenterLayout() {
  return (
    <div className="flex flex-col lg:flex-row gap-6 p-6 max-w-7xl mx-auto">
      <aside className="lg:w-56 shrink-0">
        <h1 className="text-lg font-bold text-[#1B375B] mb-1">SEO / GEO Control</h1>
        <p className="text-xs text-gray-500 mb-3">Entity Priority Lists</p>
        <nav className="flex flex-wrap lg:flex-col gap-1 text-sm max-h-[80vh] overflow-y-auto">
          {NAV.map(({ to, end, label }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-lg ${isActive ? 'bg-[#1B375B] text-white' : 'text-gray-700 hover:bg-gray-100'}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
